import type { IconData } from '@stacksjs/iconify-core'

export const textFormattingTopImage: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M11.5 7h-7V0h7zM0 11.5h16V9H0zM0 16h16v-2.5H0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default textFormattingTopImage
